<script>
export default {
  BackendURL() {
    return "https://api.thaicma.org/";
  },
};
</script>